<template>
  <div ref="menuContainer" class="relative">
    <div class="cursor-pointer" @contextmenu.prevent="openMenu">
      <slot></slot>
    </div>
    <Transition>
      <div v-if="menuOpen" class="absolute top-10 z-10" @click="closeOnClick && closeMenu()">
        <slot name="menu"></slot>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  closeOnClick?: boolean
}>()

const menuOpen = ref(false)
const menuContainer = ref<HTMLElement | null>(null)

const openMenu = () => {
  menuOpen.value = true
}

const closeMenu = () => {
  menuOpen.value = false
}

const handleClickOutside = (event: MouseEvent) => {
  if (menuContainer.value && !menuContainer.value.contains(event.target as Node)) {
    closeMenu()
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>
